(function () {

    "use strict";

    angular
        .module("harriApp")
        .service("hWeatherService", hWeatherService);

    hWeatherService.$inject = [];

    function hWeatherService() {
        var self = this;
        self.getInstance = function () {
            return new hWeather();
        };
    }

    function hWeather() {
        var self = this;


        self.brand = function (brandId) {
            self.brandId = brandId;
            return self;
        };

        self.today = function () {
            return self;
        };

        self.day = function (date) {
            self.from(date).to(date);
            return self;
        };

        self.from = function (date) {
            self.startDate = date;
            return self;
        };

        self.to = function (date) {
            self.endDate = date;
            return self;
        };

        self.weekFrom = function (date) {
            self.startDate = moment(date);
            self.endDate = moment(date).add(6, 'days');
            return self;
        };

        self.weekFromNow = function () {
            var now = moment();
            self.startDate = now.clone();
            self.endDate = now.clone().add(6, 'days').startOf("day");
            return self;
        };

        self.get = function () {
            var defer = $q.defer();
            if (!self.brandId) {
                defer.reject('NO_BRAND_ID');
            }
            else {
                var start = self.startDate.clone();
                var end = self.endDate.clone();

                var today = moment().startOf('day');
                var startDaysDiffFromToday = start.diff(today, 'days');
                var endDaysDiffFromStart = end.diff(start, 'days');

                if (startDaysDiffFromToday > WeatherAPI.FUTURE_FORECAST_DAYS_LIMIT || endDaysDiffFromStart > WeatherAPI.MAX_INTERVAL_DAYS) {
                    defer.resolve([]);
                }
                else {
                    var endDaysDiffFromToday = end.diff(today, 'days');
                    if (endDaysDiffFromToday > WeatherAPI.FUTURE_FORECAST_DAYS_LIMIT) {
                        end = today.clone().add(WeatherAPI.FUTURE_FORECAST_DAYS_LIMIT, 'days');
                    }
                    var params = {
                        start_date: start.format('YYYY-MM-DD'),
                        end_date: end.format('YYYY-MM-DD')
                    };

                    WeatherAPI
                        .getWeatherDetails(self.brandId, params)
                        .then(function (data) {
                            defer.resolve(data);
                        })
                        .catch(function (err) {
                            defer.reject(err);
                        });
                }
            }

            return defer.promise;
        };
    }
})();
